import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateTestimonialSortOrderMutationVariables = Types.Exact<{
  testimonialIds: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
}>;


export type UpdateTestimonialSortOrderMutation = { __typename?: 'Mutation', updateTestimonialSortOrder: { __typename?: 'ResultResponse', count: number, error?: string | null } };


export const UpdateTestimonialSortOrderDocument = gql`
    mutation UpdateTestimonialSortOrder($testimonialIds: [Int!]!) {
  updateTestimonialSortOrder(testimonialIds: $testimonialIds) {
    count
    error
  }
}
    `;
export type UpdateTestimonialSortOrderMutationFn = Apollo.MutationFunction<UpdateTestimonialSortOrderMutation, UpdateTestimonialSortOrderMutationVariables>;

/**
 * __useUpdateTestimonialSortOrderMutation__
 *
 * To run a mutation, you first call `useUpdateTestimonialSortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestimonialSortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestimonialSortOrderMutation, { data, loading, error }] = useUpdateTestimonialSortOrderMutation({
 *   variables: {
 *      testimonialIds: // value for 'testimonialIds'
 *   },
 * });
 */
export function useUpdateTestimonialSortOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTestimonialSortOrderMutation, UpdateTestimonialSortOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTestimonialSortOrderMutation, UpdateTestimonialSortOrderMutationVariables>(UpdateTestimonialSortOrderDocument, options);
      }
export type UpdateTestimonialSortOrderMutationHookResult = ReturnType<typeof useUpdateTestimonialSortOrderMutation>;
export type UpdateTestimonialSortOrderMutationResult = Apollo.MutationResult<UpdateTestimonialSortOrderMutation>;
export type UpdateTestimonialSortOrderMutationOptions = Apollo.BaseMutationOptions<UpdateTestimonialSortOrderMutation, UpdateTestimonialSortOrderMutationVariables>;